import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, ArrowRightIcon } from 'lucide-react';
const ReferenceNumberSearch: React.FC = () => {
  const [referenceNumber, setReferenceNumber] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (referenceNumber.trim()) {
      navigate(`/track-application/${referenceNumber.trim()}`);
    }
  };
  return <form onSubmit={handleSubmit} className="w-full" data-id="element-630">
      <div className="relative" data-id="element-631">
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-632">
          <SearchIcon className={`h-5 w-5 transition-colors duration-300 ${isFocused ? 'text-green-600' : 'text-gray-400'}`} data-id="element-633" />
        </div>
        <input type="text" className={`block w-full pl-12 pr-32 py-3 border-2 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none transition-all duration-300 ${isFocused ? 'border-green-500 ring-4 ring-green-100' : 'border-gray-200 hover:border-gray-300'}`} placeholder="Enter reference number (e.g., TAX-2023-1234)" value={referenceNumber} onChange={e => setReferenceNumber(e.target.value)} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} required data-id="element-634" />
        <button type="submit" className="absolute right-2 top-1/2 transform -translate-y-1/2 px-6 py-2 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg font-medium hover:from-green-600 hover:to-green-700 transition-all duration-300 hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl flex items-center" data-id="element-635">
          Track
          <ArrowRightIcon className="h-4 w-4 ml-2" data-id="element-636" />
        </button>
      </div>
    </form>;
};
export default ReferenceNumberSearch;